module.exports = __webpack_public_path__ + "static/media/anca_elena_chirila_gheorghica.503ee83d.png";